import AuthenticatedRoute from './authenticated-route'
import ConnectedSwitch from './connected-switch'
import LogoutRoute from './logout-route'
import RedirectRoute from './redirect-route'
import RedirectPortalRoute from './redirect-portal-route'

export {
    AuthenticatedRoute,
    ConnectedSwitch,
    LogoutRoute,
    RedirectRoute,
    RedirectPortalRoute
}



// WEBPACK FOOTER //
// src/components/auth/index.js